import { Novel } from "src/models/tieup/novel/Novel"
import CommonLabel from "src/components/common/CommonLabel"
import TieupImg from "./common/TieupImg"
import React, { useCallback } from "react"
import Link from "next/link"
import routes from "routes"
import StringUtil from "src/utils/StringUtils"

type Props = {
  novel: Novel
  onClick: () => void
}

const SearchResultNovelItem: React.FC<Props> = ({ novel, onClick }) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick],
  )

  return (
    <>
      <article className="p-searchNovalResult-item">
        <div className="p-searchNovalResult-image">
          <a
            href="#modal"
            onClick={handleClick}
            className="p-searchNovalResult-image-anchor js-simplified-trigger"
          >
            <TieupImg
              src={novel.coverImage || "/img/cover.png"}
              alt={novel.title}
            />
          </a>
          <>
            {novel.user && (
              <p className="p-searchNovalResult-novel-creator">
                <Link href={routes.creatorUser(novel.user.display_name)}>
                  <a className="p-searchNovalResult-creator-anchor">
                    {novel.user.name}
                  </a>
                </Link>
              </p>
            )}
            {novel.readersNumber !== undefined && (
              <p className="p-searchNovalResult-novel-bookmark">
                ブックマーク:{" "}
                {novel.readersNumber
                  ? StringUtil.addComma(novel.readersNumber)
                  : "-"}
              </p>
            )}
          </>
        </div>
        <div className="p-searchNovalResult-detail">
          <p className="p-searchNovalResult-copy">{novel.catchCopy}</p>
          <h2 className="p-searchNovalResult-title">
            <a
              href={`#${novel.id}`}
              onClick={handleClick}
              className="p-searchNovalResult-title-anchor js-simplified-trigger"
            >
              {novel.title}
            </a>
          </h2>
          {!!novel.genres && (
            <ul className="p-searchNovalResult-genre">
              {novel.genres.map((genre) => (
                <li key={genre.id}>
                  <CommonLabel style="tertiary" text={genre.name} />
                </li>
              ))}
            </ul>
          )}
          {!!novel.hashtags && (
            <ul className="p-searchNovalResult-tag p-wordList-secondary">
              {novel.hashtags.map((h) => (
                <li key={h.id}>{h.name}</li>
              ))}
            </ul>
          )}
        </div>
      </article>
    </>
  )
}

export default SearchResultNovelItem
